<template>
  <div>
    <base-button block type="primary" class="m-0" @click="modal = true">
      {{ $t('notificationConfigs.create.btnLabel') }}
    </base-button>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('notificationConfigs.create.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('notificationConfigs.create.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <!-- select notification type -->
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('notificationConfigs.form.plugin') }}</label>
            <div class="col-md-9">
              <div class="form-group">
                <el-select
                  class="select-primary"
                  name="plugin"
                  :placeholder="$t('notificationConfigs.form.notificationTypePlaceholder')"
                  v-model="formDetails.plugin">
                  <el-option
                    v-for="option in plugins"
                    class="select-primary"
                    :value="option.value"
                    :label="$t(`notificationConfigs.plugins.${option.value}`)"
                    :key="option.plugin">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('notificationConfigs.form.eventTypes') }}</label>
            <div class="col-md-9">
              <div class="form-group">
                <el-select
                  name="events"
                  multiple
                  class="select-primary"
                  v-model="formDetails.events"
                  :placeholder="$t('notificationConfigs.form.eventTypesPlaceholder')">
                  <el-option
                    v-for="option in notificationTypes"
                    class="select-info"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('notificationConfigs.form.webhookUrl') }}</label>
            <div class="col-md-9">
              <base-input
                name="webhookUrl"
                v-validate="modelValidations.required_url"
                :error="getError('webhookUrl')"
                v-model="formDetails.webhookUrl">
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('notificationConfigs.form.environment') }}</label>
            <div class="col-md-9">
              <base-input
                v-model="formDetails.environment">
              </base-input>
            </div>
          </div>

          <div class="row" v-if="formDetails.plugin === 'discord'">
            <label class="col-sm-3 col-form-label">{{ $t('notificationConfigs.form.discord_error_message') }}</label>
            <div class="col-md-9">
              <base-input
                v-model="formDetails.discord_error_message">
              </base-input>
            </div>
          </div>

          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit">
              {{ $t('notificationConfigs.create.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {mapActions, mapState} from 'vuex'
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';

export default {
  name: 'create-system-accounts',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  data() {
    return {
      modal: false,
      alert: false,
      plugins: [
        {value: 'slack', label: 'Slack'},
        {value: 'discord', label: 'Discord'}
      ],
      formDetails: {
        plugin: 'discord',
        events: [],
        webhookUrl: '',
        environment: '',
        discord_error_message: '@here'
      },
      modelValidations: {
        required: {
          required: true
        },
        required_url: {
          url: true,
          required: true,
        }
      }
    }
  },

  computed: {
    ...mapState({
      updating: state => state.notification_config.updating,
      error: state => state.notification_config.error,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    },
    notificationTypes() {

      let extended = []
      for (let i = 0; i < this.$store.state.notification_config.notificationTypes.length; i++) {
        extended.push({
          label: this.$store.state.notification_config.notificationTypes[i],
          value: this.$store.state.notification_config.notificationTypes[i],
        })
      }
      return extended
    }
  },
  methods: {
    ...mapActions(['CreateNotificationConfig', 'LoadNotificationConfigs']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    handleRoleChange: function (role) {
      this.account.role = role
    },
    create: function () {
      let payload = {
        plugin: this.formDetails.plugin,
        events: this.formDetails.events,
        configuration: {
          webhook_url: this.formDetails.webhookUrl,
          environment: this.formDetails.environment
        }
      }

      if (this.formDetails.plugin === 'discord') {
        payload.configuration.discord_error_message = this.formDetails.discord_error_message
      }

      this.CreateNotificationConfig(payload).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('notificationConfigs.create.createdNotification', {
              plugin: payload.plugin,
              environment: payload.configuration.environment
            }),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.LoadNotificationConfigs()
          this.resetForm()
        }
      });
    },
    resetForm: function () {
      // closing dialog
      this.modal = false

      // resetting alerts
      this.alert = false;

      // resetting form
      this.formDetails = {
        plugin: 'slack',
        events: [],
        webhookUrl: '',
        environment: '',
        discord_error_message: '@here'
      }
    }
  }
}
</script>
